export default "__VITE_ASSET__BRPNyS8X__"